import React, { useState, useEffect, useContext, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { Form, Button, Row, Col } from 'react-bootstrap';
import { BsX } from 'react-icons/bs';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { FaAngleDown } from "react-icons/fa6";
import { MdArrowBack } from "react-icons/md";
import * as apicall from '../../components/Apicall';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Formik } from 'formik';
import * as Yup from 'yup';
import { FiMinusCircle } from "react-icons/fi";
import UserContext from '../../components/context/UserContext';


const CreateAvailability = () => {
  const navigate = useNavigate();
  const [currentStep, setCurrentStep] = useState(1);
  const [searchTerm, setSearchTerm] = useState('');
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [loading, setLoading] = useState(true);
  const [doctorsList, setDoctorsList] = useState([]);
  const [selectedDoctors, setSelectedDoctors] = useState([]);
  const [feeRange, setFeeRange] = useState({ fee_from: '', fee_to: '' });
  const { vendor, refreshVendorData } = useContext(UserContext);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [loadingMore, setLoadingMore] = useState(false);
  const dropdownRef = useRef(null);
  const dropdownContainerRef = useRef(null);
  const PAGE_SIZE = 30;
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState('');
  const searchTimeoutRef = useRef(null);



  const [formData, setFormData] = useState({
    appointmentDuration: '15',
    numberOfSlots: '1',
    schedule: [
      { day: 'Monday', checked: true, workingHours: [{ startTime: '', endTime: '', fee: '' }], breakTimings: [{ breakStartTime: '', breakEndTime: '' }] },
      { day: 'Tuesday', checked: true, workingHours: [{ startTime: '', endTime: '', fee: '' }], breakTimings: [{ breakStartTime: '', breakEndTime: '' }] },
      { day: 'Wednesday', checked: true, workingHours: [{ startTime: '', endTime: '', fee: '' }], breakTimings: [{ breakStartTime: '', breakEndTime: '' }] },
      { day: 'Thursday', checked: true, workingHours: [{ startTime: '', endTime: '', fee: '' }], breakTimings: [{ breakStartTime: '', breakEndTime: '' }] },
      { day: 'Friday', checked: true, workingHours: [{ startTime: '', endTime: '', fee: '' }], breakTimings: [{ breakStartTime: '', breakEndTime: '' }] },
      { day: 'Saturday', checked: false, workingHours: [{ startTime: '', endTime: '', fee: '' }], breakTimings: [{ breakStartTime: '', breakEndTime: '' }] },
      { day: 'Sunday', checked: false, workingHours: [{ startTime: '', endTime: '', fee: '' }], breakTimings: [{ breakStartTime: '', breakEndTime: '' }] }
    ]
  });

  useEffect(() => {
    fetchDoctors();
    // Refresh vendor data when component mounts
    refreshVendorData();
  }, []);

  useEffect(() => {
    if (vendor) {
      setFeeRange({
        fee_from: vendor.fee_from || '',
        fee_to: vendor.fee_to || '',
        working_hours_start: vendor.working_hours_start || '',
        working_hours_end: vendor.working_hours_end || ''
      });

      if (vendor.working_hours_start && vendor.working_hours_end) {
        setFormData(prevData => ({
          ...prevData,
          schedule: prevData.schedule.map((day, index) => ({
            ...day,
            checked: index < 5,
            workingHours: [{
              startTime: index < 5 ? vendor.working_hours_start.substring(0, 5) : '',
              endTime: index < 5 ? vendor.working_hours_end.substring(0, 5) : '',
              fee: ''
            }],
            breakTimings: [{ breakStartTime: '', breakEndTime: '' }]
          }))
        }));
      }
    } else {
      setFeeRange({ fee_from: '', fee_to: '' });
    }
  }, [vendor]);

  // Add debounce effect for search
  useEffect(() => {
    if (searchTimeoutRef.current) {
      clearTimeout(searchTimeoutRef.current);
    }

    searchTimeoutRef.current = setTimeout(() => {
      setDebouncedSearchTerm(searchTerm);
      setPage(1);
      setDoctorsList([]);
    }, 300);

    return () => {
      if (searchTimeoutRef.current) {
        clearTimeout(searchTimeoutRef.current);
      }
    };
  }, [searchTerm]);

  // Update fetchDoctors to include search term
  const fetchDoctors = async (pageNum = 1, isLoadMore = false) => {
    try {
      setLoadingMore(isLoadMore);
      const vendorId = localStorage.getItem('vendorId');
      if (!vendorId) {
        console.error('No vendor ID found');
        return;
      }

      let url = `get_service_providers?vendor_id=${vendorId}&role=5&page=${pageNum}&limit=${PAGE_SIZE}`;
      if (debouncedSearchTerm) {
        url += `&name=${encodeURIComponent(debouncedSearchTerm)}`;
      }

      const response = await apicall.get(url);

      if (response.status === 200 && Array.isArray(response.data)) {
        const formattedDoctors = response.data.map(doctor => ({
          id: doctor.id,
          user_id: doctor.user_id,
          name: `${doctor.first_name}  ${doctor.last_name || ''}`.trim(),

        }));

        if (isLoadMore) {
          setDoctorsList(prev => [...prev, ...formattedDoctors]);
        } else {
          setDoctorsList(formattedDoctors);
        }

        setHasMore(formattedDoctors.length === PAGE_SIZE);
      } else {
        console.error('Invalid response format:', response);
        if (!isLoadMore) {
          setDoctorsList([]);
        }
      }
    } catch (error) {
      console.error('Error fetching doctors:', error);
      if (!isLoadMore) {
        setDoctorsList([]);
      }
    } finally {
      setLoading(false);
      setLoadingMore(false);
    }
  };

  // Add effect to fetch doctors when search term changes
  useEffect(() => {
    fetchDoctors(1, false);
  }, [debouncedSearchTerm]);

  const handleDropdownScroll = () => {
    if (dropdownRef.current) {
      const { scrollTop, scrollHeight, clientHeight } = dropdownRef.current;
      if (scrollHeight - scrollTop <= clientHeight + 50 && hasMore && !loadingMore) {
        const nextPage = page + 1;
        setPage(nextPage);
        fetchDoctors(nextPage, true);
      }
    }
  };

  useEffect(() => {
  }, [currentStep]);

  const handleBack = () => {
    if (currentStep > 1) {
      setCurrentStep(currentStep - 1);
    } else {
      navigate('/doctors');
    }
  };

  const handleNext = () => {
    if (currentStep === 2) {
      if (selectedDoctors.length === 0) {
        toast.error('Please select at least one doctor');
        return;
      }
    }
    setCurrentStep(prevStep => prevStep + 1);
  };

  const handleDoctorSelect = (doctorId) => {
    const updatedDoctorsList = doctorsList.map(doctor =>
      doctor.id === doctorId
        ? { ...doctor, selected: !doctor.selected }
        : doctor
    );
    setDoctorsList(updatedDoctorsList);

    // Update selectedDoctors state
    const selectedDocs = updatedDoctorsList.filter(doctor => doctor.selected);
    setSelectedDoctors(selectedDocs);
  };

  const handleSubmit = async (values, { setSubmitting }) => {
    try {
      if (selectedDoctors.length === 0) {
        toast.error('Please select at least one doctor');
        return;
      }

      const requestData = {
        doctors: selectedDoctors.map(doctor => ({ user_id: doctor.id })),
        appointment_duration: parseInt(values.appointmentDuration),
        no_of_slots: parseInt(values.numberOfSlots),
        shifts: values.schedule
          .filter(day => day.checked)
          .flatMap(day => {
            const shiftsForDay = [];

            // Process all working hours for this day
            day.workingHours.forEach((workingHour, whIndex) => {
              if (!workingHour.startTime || !workingHour.endTime) {
                return; // Skip incomplete working hours
              }

              // Create the main shift with working hours
              const mainShift = {
                day: getDayNumber(day.day),
                start_time: formatTime(workingHour.startTime),
                end_time: formatTime(workingHour.endTime),
                fee: parseInt(workingHour.fee)
              };

              // Filter break timings that fall within this specific working hour
              const validBreakTimings = day.breakTimings.filter(breakTiming =>
                breakTiming.breakStartTime &&
                breakTiming.breakEndTime &&
                breakTiming.breakStartTime >= workingHour.startTime &&
                breakTiming.breakStartTime <= workingHour.endTime &&
                breakTiming.breakEndTime >= workingHour.startTime &&
                breakTiming.breakEndTime <= workingHour.endTime
              );

              if (validBreakTimings.length === 0) {
                // No break timings for this working hour, just add the main shift
                shiftsForDay.push(mainShift);
              } else {
                // Add the main shift with the first break timing
                shiftsForDay.push({
                  ...mainShift,
                  break_start_time: formatTime(validBreakTimings[0].breakStartTime),
                  break_end_time: formatTime(validBreakTimings[0].breakEndTime)
                });

                // Add additional shifts for remaining break timings (with empty working hours)
                for (let i = 1; i < validBreakTimings.length; i++) {
                  shiftsForDay.push({
                    day: getDayNumber(day.day),
                    start_time: "00:00:00",
                    end_time: "00:00:00",
                    fee: parseInt(workingHour.fee),
                    break_start_time: formatTime(validBreakTimings[i].breakStartTime),
                    break_end_time: formatTime(validBreakTimings[i].breakEndTime)
                  });
                }
              }
            });

            return shiftsForDay;
          })
      };

      const response = await apicall.post(requestData, 'bulk_create_shifts');

      if (response.status === 200) {
        toast.success('Availability created successfully', {
          onClose: () => navigate('/doctors')
        });
      }
    } catch (error) {
      console.error('Error creating availability:', error);
      toast.error('Failed to create availability');
    } finally {
      setSubmitting(false);
    }
  };

  // Helper function to convert day name to number (1-7)
  const getDayNumber = (dayName) => {
    const days = {
      'Monday': 1,
      'Tuesday': 2,
      'Wednesday': 3,
      'Thursday': 4,
      'Friday': 5,
      'Saturday': 6,
      'Sunday': 7
    };
    return days[dayName];
  };

  // Helper function to format time to HH:mm:ss
  const formatTime = (time) => {
    if (!time) return null;
    return `${time}:00`;
  };

  const timeSlotValidationSchema = Yup.object().shape({
    appointmentDuration: Yup.string().required('Appointment duration is required'),
    numberOfSlots: Yup.string().required('Number of slots is required'),
    schedule: Yup.array().of(
      Yup.object().shape({
        checked: Yup.boolean(),
        workingHours: Yup.array().of(
          Yup.object().shape({
            startTime: Yup.string()
              .test('required-if-checked', 'Start time is required when day is selected', function (value) {
                return !this.options.from[1].value.checked || (this.options.from[1].value.checked && value);
              })
              .test('start-time-within-range', 'Start time must be within vendors working hours range', function (value) {
                if (!value || !this.options.from[1].value.checked) return true;

                const apiStartTime = feeRange.working_hours_start?.substring(0, 5);
                const apiEndTime = feeRange.working_hours_end?.substring(0, 5);

                if (!apiStartTime || !apiEndTime) return true;

                return value >= apiStartTime && value <= apiEndTime;
              })
              .test('start-time-after-previous-end', 'Start time must be after previous row end time', function (value) {
                if (!value || !this.options.from[1].value.checked) return true;

                const workingHours = this.from[1].value.workingHours;
                const currentIndex = workingHours.findIndex(
                  wh => wh.startTime === value
                );

                if (currentIndex === 0) return true;

                const previousEndTime = workingHours[currentIndex - 1].endTime;
                if (!previousEndTime) return true;

                return value > previousEndTime;
              }),
            endTime: Yup.string()
              .test('required-if-checked', 'End time is required when day is selected', function (value) {
                return !this.options.from[1].value.checked || (this.options.from[1].value.checked && value);
              })
              .test('end-time-within-range', 'End time must be within vendors working hours range', function (value) {
                if (!value || !this.options.from[1].value.checked) return true;

                const apiStartTime = feeRange.working_hours_start?.substring(0, 5);
                const apiEndTime = feeRange.working_hours_end?.substring(0, 5);

                if (!apiStartTime || !apiEndTime) return true;

                return value >= apiStartTime && value <= apiEndTime;
              })
              .test('end-time-after-start', 'End time must be after start time', function (value) {
                if (!this.parent.startTime || !value) return true;
                return value > this.parent.startTime;
              }),
            fee: Yup.string()
              .test('required-if-checked', 'Fee is required when day is selected', function (value) {
                return !this.options.from[1].value.checked || (this.options.from[1].value.checked && value);
              })
              .test('fee-range', 'Fee must be within the specified range', function (value) {
                if (!value || !this.options.from[1].value.checked) return true;
                const fee = parseInt(value);
                const feeFrom = parseInt(feeRange.fee_from);
                const feeTo = parseInt(feeRange.fee_to);
                return fee >= feeFrom && fee <= feeTo;
              })
          })
        ),
        breakTimings: Yup.array().of(
          Yup.object().shape({
            breakStartTime: Yup.string()
              .test('break-start-validation', 'Break start time must be within valid working hours', function (value) {
                if (!value || !this.options.from[1].value.checked) return true;

                const day = this.options.from[1].value;
                const workingHours = day.workingHours;

                // 1. First try to validate against current row's working hours
                const currentRowValidHours = workingHours.filter(wh =>
                  wh.startTime && wh.endTime && wh.startTime !== '00:00' && wh.endTime !== '00:00'
                );

                if (currentRowValidHours.length > 0) {
                  return currentRowValidHours.some(wh =>
                    value >= wh.startTime && value <= wh.endTime
                  );
                }

                // 2. If no valid working hours in current row, look at first working hours in schedule
                const formValues = this.options.parent;
                if (formValues && formValues.schedule) {
                  const firstDayWithHours = formValues.schedule.find(day =>
                    day.workingHours.some(wh =>
                      wh.startTime && wh.endTime && wh.startTime !== '00:00' && wh.endTime !== '00:00'
                    )
                  );

                  if (firstDayWithHours) {
                    const firstValidHours = firstDayWithHours.workingHours.find(wh =>
                      wh.startTime && wh.endTime && wh.startTime !== '00:00' && wh.endTime !== '00:00'
                    );

                    if (firstValidHours) {
                      return value >= firstValidHours.startTime && value <= firstValidHours.endTime;
                    }
                  }
                }

                // 3. If no reference found, skip validation
                return true;
              }),
              
            breakEndTime: Yup.string()
            .when('breakStartTime', {
                is: (val) => !!val, 
                then: (schema) => schema.required('Break end time is required if break start time is entered'),
                otherwise: (schema) => schema
              })
              .test('break-end-after-start', 'Break end time must be after start time', function (value) {
                if (!this.parent.breakStartTime || !value) return true;
                return value > this.parent.breakStartTime;
              })
              .test('break-end-validation', 'Break end time must be within valid working hours', function (value) {
                if (!value || !this.options.from[1].value.checked) return true;

                const day = this.options.from[1].value;
                const workingHours = day.workingHours;

                // 1. First try to validate against current row's working hours
                const currentRowValidHours = workingHours.filter(wh =>
                  wh.startTime && wh.endTime && wh.startTime !== '00:00' && wh.endTime !== '00:00'
                );

                if (currentRowValidHours.length > 0) {
                  return currentRowValidHours.some(wh =>
                    value >= wh.startTime && value <= wh.endTime
                  );
                }

                // 2. If no valid working hours in current row, look at first working hours in schedule
                const formValues = this.options.parent;
                if (formValues && formValues.schedule) {
                  const firstDayWithHours = formValues.schedule.find(day =>
                    day.workingHours.some(wh =>
                      wh.startTime && wh.endTime && wh.startTime !== '00:00' && wh.endTime !== '00:00'
                    )
                  );

                  if (firstDayWithHours) {
                    const firstValidHours = firstDayWithHours.workingHours.find(wh =>
                      wh.startTime && wh.endTime && wh.startTime !== '00:00' && wh.endTime !== '00:00'
                    );

                    if (firstValidHours) {
                      return value >= firstValidHours.startTime && value <= firstValidHours.endTime;
                    }
                  }
                }

                // 3. If no reference found, skip validation
                return true;
              })
              .test('break-time-overlap', 'Break time cannot overlap with another break', function (value) {
                if (!value || !this.parent.breakStartTime) return true;

                const breakTimings = this.options.from[1].value.breakTimings;
                if (!breakTimings || breakTimings.length <= 1) return true;

                const currentBreakIndex = breakTimings.findIndex(
                  bt => bt.breakStartTime === this.parent.breakStartTime && bt.breakEndTime === value
                );

                return !breakTimings.some((bt, index) => {
                  if (index === currentBreakIndex || !bt.breakStartTime || !bt.breakEndTime) return false;

                  return (
                    (this.parent.breakStartTime >= bt.breakStartTime && this.parent.breakStartTime < bt.breakEndTime) ||
                    (value > bt.breakStartTime && value <= bt.breakEndTime) ||
                    (this.parent.breakStartTime <= bt.breakStartTime && value >= bt.breakEndTime)
                  );
                });
              })
          })
        )
      })
    )
  });


  const doctorValidationSchema = Yup.object().shape({
    doctors: Yup.array()
      .min(1, 'Please select at least one doctor')
      .required('Please select at least one doctor')
  });

  const renderDropdownContent = (values, setFieldValue) => (
    <>
      <div className="p-2" style={{ borderBottom: '1px solid #E9ECEF' }}>
        <Form.Control
          type="text"
          placeholder="Search doctors..."
          value={searchTerm}
          onChange={(e) => {
            setSearchTerm(e.target.value);
          }}
          onClick={(e) => e.stopPropagation()}
          style={{
            height: '40px',
            fontSize: '14px',
            backgroundColor: '#F8F9FA',
            border: '1px solid #E9ECEF'
          }}
        />
      </div>

      {loading ? (
        <div className="p-3 text-center">
          <span style={{ fontSize: '14px', color: '#6C757D' }}>Loading...</span>
        </div>
      ) : doctorsList.length === 0 ? (
        <div className="p-3 text-center">
          <span style={{ fontSize: '14px', color: '#6C757D' }}>
            {debouncedSearchTerm ? 'No doctors found' : 'No doctors available'}
          </span>
        </div>
      ) : (
        doctorsList.map(doctor => (
          <div
            key={doctor.id}
            className="p-2 d-flex justify-content-between align-items-center"
            style={{
              borderBottom: '1px solid #E9ECEF',
              cursor: 'pointer'
            }}
            onClick={(e) => {
              if (e.target.type !== 'checkbox') {
                handleDoctorSelect(doctor.id);
              }
            }}
          >
            <div>
              <div style={{ fontSize: '14px', fontWeight: '500' }}>{`Dr.${doctor.name}`}</div>
            </div>
            <input
              type="checkbox"
              checked={doctor.selected || false}
              onChange={() => {
                handleDoctorSelect(doctor.id);
              }}
              onClick={(e) => e.stopPropagation()}
              className="custom-checkbox"
              style={{ cursor: 'pointer', color: '#C9194A' }}
            />
          </div>
        ))
      )}

      {loadingMore && (
        <div className="p-2 text-center">
          <span style={{ fontSize: '14px', color: '#6C757D' }}>Loading more...</span>
        </div>
      )}
    </>
  );

  const renderStepContent = () => {
    switch (currentStep) {
      case 1:
        return (
          <div className="bg-white rounded p-4" style={{ width: '80%' }}>
            <h6 className="mb-4" style={{ fontSize: '16px', fontWeight: '600', color: '#212529' }}>Select Availability Type</h6>
            <div style={{ borderBottom: '1px solid #E9ECEF', margin: '20px 0', marginBottom: '10px' }} />


            {loading ? (
              <>
                <Skeleton height={40} className="mb-3" />
                <Skeleton height={40} className="mb-3" />
                <Skeleton height={40} className="mb-4" />
                <Skeleton height={40} width={120} />
              </>
            ) : (
              <Form onSubmit={(e) => e.preventDefault()}>
                <Row className="mb-4">
                  <Col md={4}>
                    <Form.Group>
                      <Form.Label >Appointment Duration</Form.Label>
                      <Form.Select
                        value={formData.appointmentDuration}
                        onChange={(e) => setFormData(prev => ({ ...prev, appointmentDuration: e.target.value }))}
                        style={{ height: '40px', width: '130px', fontSize: '14px', backgroundColor: 'white', border: '1px solid #E3EBF8' }}
                      >
                        <option>15 min</option>
                        <option>30 min</option>
                        <option>45 min</option>
                        <option>60 min</option>
                      </Form.Select>
                    </Form.Group>
                  </Col>
                  <Col md={4}>
                    <Form.Group>
                      <Form.Label>Number of slots</Form.Label>
                      <Form.Select
                        value={formData.numberOfSlots}
                        onChange={(e) => setFormData(prev => ({ ...prev, numberOfSlots: e.target.value }))}
                        style={{ height: '40px', width: '130px', fontSize: '14px', backgroundColor: 'white', border: '1px solid #E3EBF8' }}


                      >
                        {[...Array(10)].map((_, i) => (
                          <option key={i + 1} value={i + 1}>
                            {i + 1}
                          </option>
                        ))}
                      </Form.Select>
                    </Form.Group>
                  </Col>
                </Row>
                <div style={{ borderBottom: '1px solid #E9ECEF', margin: '20px 0', marginTop: '-10px' }} />
                <Button
                  variant="danger"
                  onClick={handleNext}
                  type="button"
                  className='custom-btn btn-small'

                >
                  Next
                </Button>
              </Form>
            )}
          </div>
        );
      case 2:
        return (
          <div className="bg-white rounded p-4" style={{ width: '80%' }}>
            <h6 className="mb-4 text-dark" style={{ fontSize: '16px', fontWeight: '600' }}>Select Doctors</h6>

            {loading ? (
              <>
                <Skeleton height={40} className="mb-3" />
                <div className="mb-4">
                  <Skeleton height={30} width="30%" className="mb-2" />
                  <div className="d-flex gap-2">
                    <Skeleton height={30} width={120} />
                    <Skeleton height={30} width={120} />
                    <Skeleton height={30} width={120} />
                  </div>
                </div>
                <div className="d-flex gap-2">
                  <Skeleton height={40} width={120} />
                  <Skeleton height={40} width={120} />
                </div>
              </>
            ) : (
              <Formik
                initialValues={{ doctors: selectedDoctors.map(doc => doc.id) }}
                enableReinitialize={true}
                validationSchema={doctorValidationSchema}
                onSubmit={(values, { setSubmitting }) => {
                  if (selectedDoctors.length === 0) {
                    toast.error('Please select at least one doctor');
                    setSubmitting(false);
                    return;
                  }
                  handleNext();
                  setSubmitting(false);
                }}
              >
                {({
                  values,
                  errors,
                  touched,
                  handleSubmit,
                  isSubmitting
                }) => (
                  <Form onSubmit={handleSubmit}>
                    <div className="position-relative mb-4">
                      <div
                        ref={dropdownContainerRef}
                        className="position-relative"
                      >
                        <div
                          onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                          style={{
                            border: '1px solid #E9ECEF',
                            borderRadius: '4px',
                            padding: '8px 12px',
                            cursor: 'pointer',
                            display: 'flex',
                            width: '50%',
                            justifyContent: 'space-between',
                            alignItems: 'center'
                          }}
                        >
                          <span className="text-dark bg-white" style={{ fontSize: '14px' }}>
                            {selectedDoctors.length > 0 ? `${selectedDoctors.length} doctor${selectedDoctors.length > 1 ? 's' : ''} selected` : 'Select'}
                          </span>
                          <span style={{ transform: isDropdownOpen ? 'rotate(180deg)' : 'none' }}><FaAngleDown /></span>
                        </div>

                        {isDropdownOpen && (
                          <div
                            ref={dropdownRef}
                            onScroll={handleDropdownScroll}
                            style={{
                              position: 'absolute',
                              top: '100%',
                              left: 0,
                              right: 0,
                              backgroundColor: 'white',
                              border: '1px solid #E9ECEF',
                              borderRadius: '4px',
                              marginTop: '4px',
                              zIndex: 1000,
                              width: '50%',
                              maxHeight: '300px',
                              overflowY: 'auto'
                            }}
                          >
                            {renderDropdownContent(values)}
                          </div>
                        )}
                      </div>
                    </div>

                    {errors.doctors && touched.doctors && (
                      <div className="text-danger mb-3" style={{ fontSize: '14px' }}>
                        {errors.doctors}
                      </div>
                    )}

                    {selectedDoctors.length > 0 && (
                      <>
                        <div style={{ borderBottom: '1px solid #E9ECEF', margin: '20px 0' }} />
                        <div className="mb-4">
                          <div style={{ fontSize: '14px', color: '#212529', marginBottom: '8px' }}>Selected Doctors</div>
                          <div className="d-flex flex-wrap gap-2">
                            {selectedDoctors.map(doctor => (
                              <div
                                key={doctor.id}
                                className="d-flex align-items-center"
                                style={{
                                  padding: '0px 8px',
                                  borderRadius: '16px',
                                  border: '1px solid #E9ECEF',
                                  fontSize: '14px'
                                }}
                              >
                                <span>{`Dr. ${doctor.name}`}</span>
                                <Button
                                  variant="link"
                                  className="p-0 ms-2 text-dark"
                                  onClick={() => handleDoctorSelect(doctor.id)}
                                  style={{ color: '#6C757D' }}
                                >
                                  <BsX />
                                </Button>
                              </div>
                            ))}
                          </div>
                        </div>
                      </>
                    )}

                    <div style={{ borderBottom: '1px solid #E9ECEF', margin: '20px 0' }} />

                    <div className="d-flex gap-2">
                      <Button
                        variant="outline-danger"
                        onClick={handleBack}
                        type="button"
                        style={{
                          width: '100px',
                          fontSize: '14px',
                          height: '32px',
                          borderRadius: '16px',
                          border: '1px solid #C9194A',
                          color: '#C9194A',
                          backgroundColor: 'white'
                        }}
                      >
                        Back
                      </Button>
                      <Button
                        variant="danger"
                        type="submit"
                        disabled={isSubmitting}
                        className='custom-btn btn-small'
                      >
                        Next
                      </Button>
                    </div>
                  </Form>
                )}
              </Formik>
            )}
          </div>
        );
      case 3:
        return (
          <div className="bg-white rounded p-4">
            <h6 className="mb-4 text-dark" style={{ fontSize: '16px', fontWeight: '800' }}>Create Availability</h6>

            {loading ? (
              <>
                <Row className="mb-4">
                  <Col md={3}>
                    <Skeleton height={40} className="mb-2" />
                    <Skeleton height={40} />
                  </Col>
                  <Col md={3}>
                    <Skeleton height={40} className="mb-2" />
                    <Skeleton height={40} />
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col md={2}>
                    <Skeleton height={24} />
                  </Col>
                  <Col md={4}>
                    <Skeleton height={24} />
                  </Col>
                  <Col md={3}>
                    <Skeleton height={24} />
                  </Col>
                  <Col md={3}>
                    <Skeleton height={24} />
                  </Col>
                </Row>
                {[1, 2, 3, 4, 5, 6, 7].map((_, index) => (
                  <Row key={index} className="mb-3">
                    <Col md={2}>
                      <Skeleton height={40} />
                    </Col>
                    <Col md={4}>
                      <Row>
                        <Col>
                          <Skeleton height={40} />
                        </Col>
                        <Col>
                          <Skeleton height={40} />
                        </Col>
                      </Row>
                    </Col>
                    <Col md={2} className="text-black mb-2">Fees </Col>

                    <Col md={4}>
                      <Row>
                        <Col>
                          <Skeleton height={40} />
                        </Col>
                        <Col>
                          <Skeleton height={40} />
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                ))}
                <div className="d-flex gap-2 mt-4">
                  <Skeleton height={40} width={120} />
                  <Skeleton height={40} width={120} />
                </div>
              </>
            ) : (
              <Formik
                enableReinitialize
                initialValues={formData}
                validationSchema={timeSlotValidationSchema}
                onSubmit={handleSubmit}
              >
                {({
                  values,
                  errors,
                  touched,
                  handleChange,
                  handleBlur,
                  handleSubmit,
                  setFieldValue,
                  isSubmitting,
                  validateForm
                }) => (
                  <Form onSubmit={handleSubmit}>
                    <Row className="mb-4">
                      <Col md={3}>
                        <Form.Group style={{ maxWidth: '200px' }}>
                          <Form.Label >
                            Appointment Duration
                          </Form.Label>
                          <Form.Select
                            name="appointmentDuration"
                            value={values.appointmentDuration}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            isInvalid={touched.appointmentDuration && errors.appointmentDuration}
                            className='form-text'
                          >
                            <option value="15">15 min</option>
                            <option value="30">30 min</option>
                            <option value="45">45 min</option>
                            <option value="60">60 min</option>
                          </Form.Select>
                          {touched.appointmentDuration && errors.appointmentDuration && (
                            <Form.Control.Feedback type="invalid">{errors.appointmentDuration}</Form.Control.Feedback>
                          )}
                        </Form.Group>
                      </Col>
                      <Col md={3}>
                        <Form.Group style={{ maxWidth: '200px' }}>
                          <Form.Label >
                            Number of slots
                          </Form.Label>
                          <Form.Select
                            name="numberOfSlots"
                            value={values.numberOfSlots}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            isInvalid={touched.numberOfSlots && errors.numberOfSlots}
                            className="form-text"
                          >
                            {[...Array(10)].map((_, i) => (
                              <option key={i + 1} value={i + 1}>
                                {i + 1}
                              </option>
                            ))}
                          </Form.Select>

                          {touched.numberOfSlots && errors.numberOfSlots && (
                            <Form.Control.Feedback type="invalid">{errors.numberOfSlots}</Form.Control.Feedback>
                          )}
                        </Form.Group>
                      </Col>
                      <Col className="d-flex justify-content-end align-items-end me-5">
                        <div
                          onClick={() => {
                            // Find the first checked day
                            const firstCheckedIndex = values.schedule.findIndex(day => day.checked);
                            if (firstCheckedIndex === -1) return; // No checked day, do nothing

                            values.schedule.forEach((_, idx) => {
                              if (idx !== firstCheckedIndex) {
                                setFieldValue(
                                  `schedule.${idx}.workingHours`,
                                  values.schedule[firstCheckedIndex].workingHours.map(wh => ({ ...wh }))
                                );
                                setFieldValue(
                                  `schedule.${idx}.breakTimings`,
                                  values.schedule[firstCheckedIndex].breakTimings.map(bt => ({ ...bt }))
                                );
                                setFieldValue(`schedule.${idx}.checked`, values.schedule[firstCheckedIndex].checked);
                              }
                            });
                          }}
                          className="apply-to-all custom-btn btn-larges">
                          Apply to All Weeks
                        </div>
                      </Col>


                    </Row>

                    <div className="divide-border mb-4 mt-n2" />
                    <div className="mb-3">
                      <Row className="mb-2 align-items-center" style={{ fontWeight: 600, fontSize: 14 }}>
                        <Col md={2} className="text-dark mb-2">Days</Col>
                        <Col md={4} className="text-black mb-2">
                          Working Hours
                          {feeRange.working_hours_start && feeRange.working_hours_end && (
                            <span className="text-muted" style={{ fontSize: '12px', fontWeight: 'normal' }}>
                              ({feeRange.working_hours_start.substring(0, 5)} - {feeRange.working_hours_end.substring(0, 5)})
                            </span>
                          )}
                        </Col>
                        <Col md={2} className="text-dark mb-2">
                          Fee  <span className="text-muted" style={{ fontSize: '12px', fontWeight: 'normal' }}>
                            (Range : {feeRange.fee_from} - {feeRange.fee_to} AED)</span>
                        </Col>

                        <Col md={4} className="text-black mb-2">
                          Break Timing <span className="text-muted">(optional)</span>
                        </Col>
                      </Row>

                      {values.schedule?.map((day, index) => (
                        <Row key={day.day} className="mb-3">
                          <Col md={2}>
                            <Form.Check
                              type="checkbox"
                              id={`schedule.${index}.checked`}
                              name={`schedule.${index}.checked`}
                              label={['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'][index]}
                              checked={values.schedule[index].checked}
                              onChange={async (e) => {
                                const isChecked = e.target.checked;
                                await setFieldValue(`schedule.${index}.checked`, isChecked);

                                if (!isChecked) {
                                  await setFieldValue(`schedule.${index}.workingHours`, [{ startTime: '', endTime: '', fee: '' }]);
                                  await setFieldValue(`schedule.${index}.breakTimings`, [{ breakStartTime: '', breakEndTime: '' }]);
                                }

                                validateForm();
                              }}
                              style={{ fontSize: '14px' }}
                              className="custom-checkbox"
                            />
                          </Col>
                          <Col md={4}>
                            {values.schedule[index].workingHours.map((wh, whIdx) => (
                              <Row key={whIdx} className="mb-2">
                                <Col>
                                  <Form.Control
                                    type="time"
                                    name={`schedule.${index}.workingHours.${whIdx}.startTime`}
                                    value={wh.startTime}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    disabled={!values.schedule[index].checked}
                                    isInvalid={
                                      touched.schedule?.[index]?.workingHours?.[whIdx]?.startTime &&
                                      errors.schedule?.[index]?.workingHours?.[whIdx]?.startTime &&
                                      values.schedule[index].checked
                                    }
                                    className='form-text'
                                  />
                                  {touched.schedule?.[index]?.workingHours?.[whIdx]?.startTime &&
                                    errors.schedule?.[index]?.workingHours?.[whIdx]?.startTime &&
                                    values.schedule[index].checked && (
                                      <Form.Control.Feedback type="invalid">
                                        {errors.schedule[index].workingHours[whIdx].startTime}
                                      </Form.Control.Feedback>
                                    )}
                                </Col>
                                <Col>
                                  <Form.Control
                                    type="time"
                                    name={`schedule.${index}.workingHours.${whIdx}.endTime`}
                                    value={wh.endTime}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    disabled={!values.schedule[index].checked}
                                    isInvalid={
                                      touched.schedule?.[index]?.workingHours?.[whIdx]?.endTime &&
                                      errors.schedule?.[index]?.workingHours?.[whIdx]?.endTime &&
                                      values.schedule[index].checked
                                    }
                                    className='form-text'
                                  />
                                  {touched.schedule?.[index]?.workingHours?.[whIdx]?.endTime &&
                                    errors.schedule?.[index]?.workingHours?.[whIdx]?.endTime &&
                                    values.schedule[index].checked && (
                                      <Form.Control.Feedback type="invalid">
                                        {errors.schedule[index].workingHours[whIdx].endTime}
                                      </Form.Control.Feedback>
                                    )}
                                </Col>
                                <Col xs={2} className="d-flex justify-content-center">
                                  {values.schedule[index].workingHours.length > 1 && (
                                    <button
                                      type="button"
                                      onClick={() => {
                                        const newSchedule = [...values.schedule];
                                        const newWorkingHours = newSchedule[index].workingHours.filter((_, idx) => idx !== whIdx);
                                        newSchedule[index] = {
                                          ...newSchedule[index],
                                          workingHours: newWorkingHours,
                                          breakTimings: newSchedule[index].breakTimings.filter((_, idx) => idx !== whIdx)
                                        };
                                        setFieldValue('schedule', newSchedule);
                                      }}
                                      className="btn p-0 border-0 bg-transparent d-flex align-items-center justify-content-center"

                                      aria-label="Remove working hours"
                                    >
                                      <FiMinusCircle size={24} />
                                    </button>
                                  )}
                                </Col>
                              </Row>
                            ))}
                            {values.schedule[index].checked && (
                              <Button
                                variant="light"
                                size="sm"
                                onClick={() => {
                                  const newSchedule = [...values.schedule];
                                  newSchedule[index] = {
                                    ...newSchedule[index],
                                    workingHours: [
                                      ...newSchedule[index].workingHours,
                                      { startTime: '', endTime: '', fee: '' }
                                    ]
                                  };
                                  setFieldValue('schedule', newSchedule);
                                }}
                                className="add-row-btn">
                                Add Row
                              </Button>
                            )}
                          </Col>
                          <Col md={2}>
                            {values.schedule[index].workingHours.map((wh, whIdx) => (
                              <Row key={whIdx} className="mb-2">
                                <Col>
                                  <Form.Control
                                    type="number"
                                    name={`schedule.${index}.workingHours.${whIdx}.fee`}
                                    value={wh.fee}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    placeholder="Fee"
                                    disabled={!values.schedule[index].checked}
                                    isInvalid={
                                      touched.schedule?.[index]?.workingHours?.[whIdx]?.fee &&
                                      errors.schedule?.[index]?.workingHours?.[whIdx]?.fee &&
                                      values.schedule[index].checked
                                    }
                                    className='form-text'
                                  />
                                  {touched.schedule?.[index]?.workingHours?.[whIdx]?.fee &&
                                    errors.schedule?.[index]?.workingHours?.[whIdx]?.fee &&
                                    values.schedule[index].checked && (
                                      <Form.Control.Feedback type="invalid">
                                        {errors.schedule[index].workingHours[whIdx].fee}
                                      </Form.Control.Feedback>
                                    )}
                                </Col>
                              </Row>
                            ))}
                          </Col>
                          <Col md={4}>
                            {values.schedule[index].breakTimings.map((breakTime, breakIdx) => (
                              <Row key={breakIdx} className="mb-2">
                                <Col>
                                  <Form.Control
                                    type="time"
                                    name={`schedule.${index}.breakTimings.${breakIdx}.breakStartTime`}
                                    value={breakTime.breakStartTime}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    disabled={!values.schedule[index].checked}
                                    isInvalid={
                                      touched.schedule?.[index]?.breakTimings?.[breakIdx]?.breakStartTime &&
                                      errors.schedule?.[index]?.breakTimings?.[breakIdx]?.breakStartTime &&
                                      values.schedule[index].checked
                                    }
                                    className='form-text'
                                  />
                                  {touched.schedule?.[index]?.breakTimings?.[breakIdx]?.breakStartTime &&
                                    errors.schedule?.[index]?.breakTimings?.[breakIdx]?.breakStartTime &&
                                    values.schedule[index].checked && (
                                      <Form.Control.Feedback type="invalid">
                                        {errors.schedule[index].breakTimings[breakIdx].breakStartTime}
                                      </Form.Control.Feedback>
                                    )}
                                </Col>
                                <Col>
                                  <Form.Control
                                    type="time"
                                    name={`schedule.${index}.breakTimings.${breakIdx}.breakEndTime`}
                                    value={breakTime.breakEndTime}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    disabled={!values.schedule[index].checked}
                                    isInvalid={
                                      touched.schedule?.[index]?.breakTimings?.[breakIdx]?.breakEndTime &&
                                      errors.schedule?.[index]?.breakTimings?.[breakIdx]?.breakEndTime &&
                                      values.schedule[index].checked
                                    }
                                    className='form-text'
                                  />
                                  {touched.schedule?.[index]?.breakTimings?.[breakIdx]?.breakEndTime &&
                                    errors.schedule?.[index]?.breakTimings?.[breakIdx]?.breakEndTime &&
                                    values.schedule[index].checked && (
                                      <Form.Control.Feedback type="invalid">
                                        {errors.schedule[index].breakTimings[breakIdx].breakEndTime}
                                      </Form.Control.Feedback>
                                    )}
                                </Col>
                                <Col xs={2} className="d-flex justify-content-center">
                                  {values.schedule[index].breakTimings.length > 1 && (
                                    <button
                                      type="button"
                                      onClick={() => {
                                        const newSchedule = [...values.schedule];
                                        const newBreakTimings = newSchedule[index].breakTimings.filter((_, idx) => idx !== breakIdx);
                                        newSchedule[index] = {
                                          ...newSchedule[index],
                                          breakTimings: newBreakTimings
                                        };
                                        setFieldValue('schedule', newSchedule);
                                      }}
                                      className="btn p-0 border-0 bg-transparent d-flex align-items-center justify-content-center"

                                      aria-label="Remove break"
                                    >
                                      <FiMinusCircle size={24} />
                                    </button>
                                  )}
                                </Col>
                              </Row>
                            ))}
                            {values.schedule[index].checked && (
                              <Button
                                variant="light"
                                size="sm"
                                onClick={() => {
                                  const newSchedule = [...values.schedule];
                                  newSchedule[index] = {
                                    ...newSchedule[index],
                                    breakTimings: [
                                      ...newSchedule[index].breakTimings,
                                      { breakStartTime: '', breakEndTime: '' }
                                    ]
                                  };
                                  setFieldValue('schedule', newSchedule);
                                }}
                                className="add-row-btn">
                                Add Row
                              </Button>
                            )}
                          </Col>
                        </Row>
                      ))}
                    </div>

                    <div className="d-flex gap-2 mt-4">
                      <Button
                        variant="outline-danger"
                        onClick={handleBack}
                        type="button"
                        style={{
                          width: '100px',
                          fontSize: '14px',
                          height: '32px',
                          borderRadius: '16px',
                          border: '1px solid #C9194A',
                          color: '#C9194A',
                          backgroundColor: 'white'
                        }}
                      >
                        Back
                      </Button>
                      <Button
                        variant="danger"
                        type="submit"
                        disabled={isSubmitting}
                        className='custom-btn btn-small'
                      >
                        Submit
                      </Button>
                    </div>
                  </Form>
                )}
              </Formik>
            )}
          </div>
        );
      default:
        return null;
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropdownContainerRef.current &&
        !dropdownContainerRef.current.contains(event.target)
      ) {
        setIsDropdownOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <div className="px-4" style={{ backgroundColor: '#F2F5FA', minHeight: '100vh' }}>
      <div className="d-flex align-items-center mb-3 pt-3">
        <Button
          variant="link"
          className="text-dark text-decoration-none p-0 d-flex align-items-center"
          onClick={handleBack}
          style={{ fontSize: '14px' }}
        >
          <MdArrowBack size={20} /> BACK
        </Button>
      </div>

      <h4 className="mb-4" style={{ fontSize: '24px', fontWeight: '600', color: '#212529' }}>Create Availability</h4>

      {/* Stepper */}
      <div className="d-flex align-items-center mb-4">
        {/* Step 1: Availability Type */}
        <div className="d-flex align-items-center">
          <div
            className="rounded-circle d-flex align-items-center justify-content-center"
            style={{
              width: '24px',
              height: '24px',
              backgroundColor: currentStep > 1 ? '#000' : (currentStep === 1 ? '#000' : '#DBDBDB'),
              border: currentStep >= 1 ? 'none' : '1px solid #E9ECEF',
              color: currentStep > 1 ? '#fff' : (currentStep === 1 ? '#fff' : '#898989'),
              fontSize: currentStep > 1 ? '16px' : '14px',
              fontWeight: '500'
            }}
          >
            {currentStep > 1 ? '✓' : '1'}
          </div>
          <span className="ms-2" style={{ fontSize: '14px', color: '#000', fontWeight: currentStep >= 1 ? '500' : '400' }}>Availability Type</span>
        </div>

        {/* Connector line */}
        <div className="mx-3" style={{ width: '100px', height: '1px', backgroundColor: '#DBDBDB' }}></div>

        {/* Step 2: Select Doctors */}
        <div className="d-flex align-items-center">
          <div
            className="rounded-circle d-flex align-items-center justify-content-center"
            style={{
              width: '24px',
              height: '24px',
              backgroundColor: currentStep > 2 ? '#000' : (currentStep === 2 ? '#000' : '#DBDBDB'),
              border: currentStep >= 2 ? 'none' : '1px solid #E9ECEF',
              color: currentStep > 2 ? '#fff' : (currentStep === 2 ? '#fff' : '#898989'),
              fontSize: currentStep > 2 ? '16px' : '14px',
              fontWeight: '500'
            }}
          >
            {currentStep > 2 ? '✓' : '2'}
          </div>
          <span className="ms-2" style={{ fontSize: '14px', color: '#000', fontWeight: currentStep >= 2 ? '500' : '400' }}>Select Doctors</span>
        </div>

        {/* Connector line */}
        <div className="mx-3" style={{ width: '100px', height: '1px', backgroundColor: '#DBDBDB' }}></div>

        {/* Step 3: Set Time Slots */}
        <div className="d-flex align-items-center">
          <div
            className="rounded-circle d-flex align-items-center justify-content-center"
            style={{
              width: '24px',
              height: '24px',
              backgroundColor: currentStep > 3 ? '#000' : (currentStep === 3 ? '#000' : '#DBDBDB'),
              border: currentStep >= 3 ? 'none' : '1px solid #E9ECEF',
              color: currentStep > 3 ? '#fff' : (currentStep === 3 ? '#fff' : '#898989'),
              fontSize: currentStep > 3 ? '16px' : '14px',
              fontWeight: '500'
            }}
          >
            {currentStep > 3 ? '✓' : '3'}
          </div>
          <span className="ms-2" style={{ fontSize: '14px', color: '#000', fontWeight: currentStep >= 3 ? '500' : '400' }}>Set Time Slots</span>
        </div>
      </div>
      {renderStepContent()}
    </div>
  );
};

export default CreateAvailability;